<template>
  <div class='page-wrap'>
    <div class="page-box">
      <div class="text-item">正在打开小程序 ...</div>
      <van-button :block="true" class="btn-box" type="primary" size="small" >打开小程序</van-button>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data () {
    return {}
  },
  created () { },
  mounted () {
  },
  methods: {
  },
  computed: {},
  watch: {},
}
</script>

<style lang='scss' scoped>
.page-wrap {
  height:100vh;
  display:flex;
  align-items: center;
  justify-content:center;
}
.text-item{
  padding-bottom:80px;
  text-align:center;
}
.page-box{
  flex:1;
}
.btn-box{
  margin:0 auto;
  width:160px;
}
</style>